import React from "react";
import { SCENARIO } from "../scenario/torbridge.js";
import { RAW_AGENT_OUTPUT } from "../data.js";
import { CollapsibleJson } from "./JsonView.js";

// The L0 baseline: an agent doing something, with no verifiability. This is
// the "here's a screenshot, trust me" state the rest of the demo improves on.
export function AgentScreen() {
  const { task, agentSteps, agentDecision, incomingInvoice: inv } = SCENARIO;
  return (
    <div className="agent-screen">
      <div className="incoming">
        <div className="incoming-head">
          <span className="incoming-tag">Incoming</span>
          <span className="incoming-meta">
            {inv.inbox} · {inv.receivedAt}
          </span>
        </div>
        <div className="invoice-doc">
          <div className="invoice-doc-head">
            <div>
              <div className="invoice-vendor">{inv.vendor}</div>
              <div className="invoice-sub">
                Invoice {inv.invoiceId} · {inv.poNumber} · issued {inv.issuedAt}
              </div>
            </div>
            <div className="invoice-total">{inv.totalLabel}</div>
          </div>
          <table className="invoice-lines">
            <thead>
              <tr>
                <th scope="col">Description</th>
                <th scope="col" className="num">
                  Qty
                </th>
                <th scope="col" className="num">
                  Unit
                </th>
                <th scope="col" className="num">
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              {inv.lineItems.map((li, i) => (
                <tr key={i}>
                  <td>{li.description}</td>
                  <td className="num">{li.qty}</td>
                  <td className="num">${li.unitUsd.toLocaleString()}</td>
                  <td className="num">${(li.qty * li.unitUsd).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>Total</td>
                <td className="num">{inv.totalLabel}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <p className="incoming-note">{inv.note}</p>
        <div className="incoming-explainer">
          {inv.explainer.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      </div>

      <div className="agent-screen-head">
        <span className="agent-avatar" aria-hidden="true">
          {"{ }"}
        </span>
        <div>
          <div className="agent-name">{task.agentId}</div>
          <div className="agent-role">
            Delegated by {task.delegator} · {task.title}
          </div>
        </div>
      </div>

      <div className="agent-prompt">
        <div className="agent-prompt-label">Task prompt</div>
        <p>{task.prompt}</p>
        <p className="agent-authority">{task.authority}</p>
      </div>

      <div className="agent-stream">
        {agentSteps.map((step) => (
          <div className="agent-step" key={step.id}>
            <span className="agent-step-dot" aria-hidden="true" />
            <div>
              <code className="agent-step-label">{step.label}</code>
              <div className="agent-step-detail">{step.detail}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="agent-decision">
        <div className="agent-decision-label">Agent output</div>
        <p>{agentDecision}</p>
      </div>

      <div className="agent-raw">
        <CollapsibleJson
          title={SCENARIO.copy.rawOutput.title}
          subtitle="what the agent actually produced"
          json={RAW_AGENT_OUTPUT}
          defaultOpen
        />
        <div className="agent-raw-explainer">
          {SCENARIO.copy.rawOutput.explainer.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      </div>

      <div className="agent-caveat">
        This is raw model output. There is nothing to verify: no signatures, no hash chain, no way
        to know the transcript above was not edited after the fact. Everything below adds a layer
        that a third party can check.
      </div>
    </div>
  );
}
